import React from "react";
import '../ReportsPdfData/ReportsPdfData.scss';
import CommonTable from "../../components/Table/CommonTable";

function ReportsPdfData({ title, columnsOptions, rowData }) {
  return (
    <>
      <div className="reports-pdfdata-block">
        <div className="row">
          <div className="col-md-12">
            <div className="reports-data-table-wrap">
              <div className="card">
                <div className="card-body">
                  <div className="home-table-chart-box">
                    <div className="top_bar">
                      <div className="card_title">{title}</div>
                    </div>
                    <CommonTable columns={columnsOptions} rows={rowData}/>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ReportsPdfData;
